

import ContactForm1 from "./form1";
import ContactForm2 from "./form2";

export default function Contact({
    options,
    data 
}) {

    const type = options.type ; // 1 2 3 4

    if(type === 1) {
        return <ContactForm1
            options={options}
            data={data}
        />
    }

    if(type === 2) {
        return <ContactForm2 
                options={options}
                data={data}
        />
    }

    

    return (
        <div></div>
    )
}
